import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import pdf from "../../../../assets/img/pdf.png";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_AntiRaggingDocument = () => {
  const [data, setData] = useState(null);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.antiRaggingDocument, setData);
  }, [currentDomain]);

  const documentsData = data?.data?.attributes?.links || [];

  return (
    <React.Fragment>
      <Helmet>
        <title>Anti Ragging Documents | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="Anti-ragging documents, guidelines, and policies at Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Anti Ragging, Documents, Guidelines, OTPRI, JNTUA, Student Safety"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .documents-table-wrapper {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,123,255,0.1);
                        overflow-x: auto;
                        margin-bottom: 30px;
                    }

                    .documents-table {
                        margin-bottom: 0;
                        background: #fff;
                    }

                    .documents-table thead {
                        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                        color: white;
                    }

                    .documents-table thead th {
                        border: none;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        padding: 18px 15px;
                        font-size: calc(${fontSize}px - 1px);
                        white-space: nowrap;
                        vertical-align: middle;
                    }

                    .documents-table tbody td {
                        padding: 15px;
                        vertical-align: middle;
                        border-color: #e3f2fd;
                    }

                    .document-name-cell {
                        font-weight: 600;
                        color: #007bff;
                        font-size: calc(${fontSize}px + 1px);
                        min-width: 300px;
                    }

                    .view-document-btn {
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        padding: 8px 20px;
                        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                        color: white;
                        text-decoration: none;
                        border-radius: 5px;
                        font-weight: 500;
                        transition: all 0.3s ease;
                        border: none;
                        cursor: pointer;
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .view-document-btn:hover {
                        background: linear-gradient(135deg, #0056b3 0%, #003d82 100%);
                        color: white;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 12px rgba(0,123,255,0.3);
                    }

                    .view-document-btn img {
                        width: 18px;
                        height: 18px;
                        filter: brightness(0) invert(1);
                    }

                    .no-data-cell {
                        text-align: center;
                        padding: 60px 20px;
                        color: #999;
                    }

                    .no-data-cell i {
                        font-size: 60px;
                        color: #ddd;
                        margin-bottom: 20px;
                        display: block;
                    }

                    .no-data-cell h5 {
                        color: #666;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }

                    @media (max-width: 768px) {
                        .documents-table {
                            font-size: calc(${fontSize}px - 2px);
                        }

                        .documents-table thead th,
                        .documents-table tbody td {
                            padding: 10px 8px;
                        }

                        .document-name-cell {
                            min-width: 200px;
                        }

                        .view-document-btn {
                            padding: 6px 15px;
                            font-size: calc(${fontSize}px - 3px);
                        }
                    }
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Anti Ragging Documents"
          pageName="Anti Ragging Documents"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title text-center mb-5">
                      Anti Ragging Documents
                    </h3>
                    
                    <div className="documents-table-wrapper">
                      {documentsData.length > 0 ? (
                        <table className="table table-striped table-bordered documents-table">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Document Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documentsData.map((document, index) => {
                              const pdfUrl = document?.content?.data?.attributes?.url;
                              const pdfName = document?.content?.data?.attributes?.name;
                              return (
                                <tr key={document.id || index}>
                                  <td>{index + 1}</td>
                                  <td className="document-name-cell">
                                    {document?.label || "N/A"}
                                  </td>
                                  <td>
                                    {pdfUrl ? (
                                      <a
                                        href={imageBaseURL + pdfUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="view-document-btn"
                                        title={pdfName || document.label}
                                      >
                                        <img src={pdf} alt="PDF" />
                                        <span>View Document</span>
                                      </a>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div className="no-data-cell">
                          <i className="fas fa-file-alt"></i>
                          <h5>No documents available at the moment.</h5>
                          <p>Please check back later for anti-ragging documents.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_AntiRaggingDocument;
